import { Fragment } from "react";
import TimeRequiredIcon from '../../../../icons/timeRequired.svg?react';
import CarrierRatingIcon from '../../../../icons/carrierRating.svg?react';
import SecureInformationIcon from '../../../../icons/secureInformation.svg?react';

const Disclaimer = <Fragment>
    <p>By clicking Continue, you are providing your signed permission for Covr Financial Technologies to contact you at
        the email and telephone number provided, including via text message and live, automated and pre-recorded telephone
        calls, even if your number is on a Do Not Call list. You also acknowledge that you have received and agree to our
        Privacy Policy, Terms of Use, and Consent to Do Business Electronically. You may revoke these consents at any time
        by emailing us at <a href="mailto:support@covrtech.com">SUPPORT@COVRTECH.COM.</a></p>
</Fragment>

const LGAPlanFeatures = [
    {
        icon: TimeRequiredIcon,
        text: "Submit your application today with an all digital process"
    },
    {
        icon: CarrierRatingIcon,
        text: "AM Best has rated this carrier as A+"
    },
    {
        icon: SecureInformationIcon,
        text: "End-to-end 256-bit encryption protects you every step of the way"
    },
];

const LGAHandoffMessage = "Please wait a moment while we transfer your information to Legal & General to start your electronic application. It only takes about 15 minutes and no payment is required.";

const PrudentialPlanFeatures = [
    {
        icon: TimeRequiredIcon,
        text: "Submit your application and get a decision today with an all digital process"
    },
    {
        icon: CarrierRatingIcon,
        text: "AM Best has rated this carrier as A+"
    },
];

const PrudentialHandoffMessage = "Please wait a moment while we prepare your application.";

export {
    Disclaimer,
    LGAPlanFeatures,
    LGAHandoffMessage,
    PrudentialPlanFeatures,
    PrudentialHandoffMessage,
};
